import script from "./NewCertificate.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewCertificate.vue?vue&type=script&setup=true&lang=ts"

import "./NewCertificate.vue?vue&type=style&index=0&id=35c00a5c&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c00a5c"]])

export default __exports__